// Types for reload are wrong, just just made JS
export const forcePageRefresh = () => window.location.reload(true);
